import React, { useState, useEffect, useRef } from "react";
import { Col, Container, Row, Button } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { useLocation, useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import "react-bootstrap-typeahead/css/Typeahead.css";
import axios from "axios";
import PubSub from "pubsub-js";
import solisPowerApi from "../../api/solisPowerApi";
import SpinnerOverlay from "./SpinnerOverlay";
import moment from "moment";

const FilesCreate = (props) => {
  const [validated, setValidated] = useState(false);
  const [loading, setLoading] = useState(false);
  const [description, setDescription] = useState("");

  // Folder wise files
  const [filesByFolder, setFilesByFolder] = useState({
    BuildingPhoto: [],
    RoofPhotos: [],
    ProductLocation: [],
    LayoutPhoto: [],
  });

  const folderList = [
    { label: "Building photo", key: "BuildingPhoto" },
    { label: "Roof photos", key: "RoofPhotos" },
    { label: "Product location", key: "ProductLocation" },
    { label: "Layout photo", key: "LayoutPhoto" },
  ];

  //  Refs for file inputs
  const fileRefs = {
    BuildingPhoto: useRef(),
    RoofPhotos: useRef(),
    ProductLocation: useRef(),
    LayoutPhoto: useRef(),
  };

  const handleFileChange = (folderKey, files) => {
    setFilesByFolder((prev) => ({
      ...prev,
      [folderKey]: Array.from(files),
    }));
  };

  const isFormInvalid = () => {
    return !Object.values(filesByFolder).some((files) => files.length > 0);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isFormInvalid()) {
      setValidated(true);
      return;
    }

    setLoading(true);

    const formData = new FormData();

    // EXACT SAME BACKEND CONTRACT
    Object.entries(filesByFolder).forEach(([folder, files]) => {
      files.forEach((file) => {
        formData.append(folder, file);
      });
    });

    formData.append("description", description);

    try {
      await solisPowerApi.createFile(props.parent.id, formData);
      props?.submitFiles();
    } catch (err) {
      console.error("Upload failed", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal {...props} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Upload Files</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <SpinnerOverlay loading={loading} />

        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          {/* FILE UPLOAD BUTTONS – SINGLE ROW */}
          <Form.Group className="mb-4">
            <div className="d-flex gap-3" style={{ flexWrap: "nowrap" }}>
              {folderList.map((folder, index) => {
                const variants = ["primary", "secondary", "success", "warning"];

                return (
                  <div key={folder.key}>
                    <Button
                      variant={variants[index]}
                      onClick={() => fileRefs[folder.key].current.click()}
                    >
                      {folder.label}
                    </Button>

                    {/* Hidden file input */}
                    <Form.Control
                      type="file"
                      multiple
                      ref={fileRefs[folder.key]}
                      style={{ display: "none" }}
                      onChange={(e) =>
                        handleFileChange(folder.key, e.target.files)
                      }
                    />

                    {/* File count */}
                    {filesByFolder[folder.key].length > 0 && (
                      <small className="text-success d-block mt-1">
                        {filesByFolder[folder.key].length} files
                      </small>
                    )}
                  </div>
                );
              })}
            </div>
          </Form.Group>

          {/* DESCRIPTION */}
          <Form.Group className="mt-2">
            <Form.Label>Description</Form.Label>
            <Form.Control
              as="textarea"
              placeholder="Enter description"
              onChange={(e) => setDescription(e.target.value)}
            />
          </Form.Group>

          {/* ACTION BUTTONS */}
          <div className="d-flex justify-content-end gap-2 mt-4">
            <Button variant="success" type="submit" disabled={loading}>
              Submit
            </Button>
            <Button variant="light" onClick={props.onHide}>
              Close
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default FilesCreate;
